import $ from 'jquery';

export default () => {
  const $dropdown = $('input[name=tags]').closest('.dropdown');

  $dropdown.dropdown({
    allowAdditions: true,
    direction: 'upward',
  });
  $dropdown.on('keypress', evt => {
    if (evt.keyCode === 13) {
      evt.preventDefault();
    }
  });
};



// WEBPACK FOOTER //
// ./src/plugins/tags.js